import Profile from "./Profile";
import Stack from "./Stack";
import LayoutWithNav from "./LayoutWithNav";
import PageHeader from "./PageHeader";
import { UserIcon, UsersIcon } from "lucide-react";
import UserCRUD from "./UserCRUD";
import InviteCRUD from "./InviteCRUD";

export default function AccountPage() {
  return (
    <LayoutWithNav>
      <PageHeader icon={<UserIcon className="w-6 h-6" />}>Account</PageHeader>
      <Profile />
      <PageHeader icon={<UsersIcon className="w-6 h-6" />}>Family</PageHeader>
      <Stack>
        <UserCRUD />
        <InviteCRUD />
      </Stack>
    </LayoutWithNav>
  );
}
